import { Locale } from '@kamernet/core/Intl/types';

export const SupportLinkByLocale = {
  [Locale.en]: 'https://support.kamernet.nl/en',
  [Locale.nl]: 'https://support.kamernet.nl',
};
